import { render, staticRenderFns } from "./FormManager.vue?vue&type=template&id=3bd894e4&scoped=true&"
import script from "./FormManager.vue?vue&type=script&lang=js&"
export * from "./FormManager.vue?vue&type=script&lang=js&"
import style0 from "./FormManager.vue?vue&type=style&index=0&id=3bd894e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd894e4",
  null
  
)

export default component.exports